// --- CONFIGURATION ---
const HOSTINGER_API_URL = "https://onyxcrm.onyxmachinery.in/api.php"; 

// --- THEME CONFIGURATION (REDESIGNED: FLUIDIC GLASS) ---
const THEMES = {
  light: {
    bg: "bg-transparent", // Handled by BackgroundOrbs
    text: "text-slate-700",
    textMuted: "text-slate-500",
    heading: "text-slate-800 tracking-tight",
    // Glass Card
    card: "bg-white/60 backdrop-blur-2xl border border-white/60 shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_8px_30px_rgb(0,0,0,0.08)] transition-all duration-300 rounded-[2rem]",
    // Glass Sidebar
    sidebar: "bg-white/50 backdrop-blur-3xl border-r border-white/40 shadow-2xl",
    sidebarText: "text-slate-500 font-medium hover:text-blue-600 transition-colors",
    sidebarActive: "bg-gradient-to-r from-blue-600 to-blue-500 text-white shadow-lg shadow-blue-500/30 scale-105",
    // Glass Input
    input: "bg-white/40 border border-white/60 focus:bg-white/80 focus:border-blue-400 focus:ring-4 focus:ring-blue-500/10 transition-all rounded-2xl text-slate-700 placeholder:text-slate-400 font-medium",
    tableHeader: "bg-blue-50/50 text-blue-900/70 font-bold uppercase tracking-wider border-b border-white/50",
    tableRow: "hover:bg-white/40 border-b border-slate-100/50 last:border-0 transition-colors duration-200",
    badge: {
      Draft: "bg-slate-100/80 text-slate-600 border-slate-200 backdrop-blur-md",
      Sent: "bg-blue-50/80 text-blue-600 border-blue-200 backdrop-blur-md",
      "Follow Up": "bg-orange-50/80 text-orange-600 border-orange-200 backdrop-blur-md",
      "Order Confirmed": "bg-emerald-50/80 text-emerald-600 border-emerald-200 backdrop-blur-md",
      Rejected: "bg-red-50/80 text-red-600 border-red-200 backdrop-blur-md"
    }
  },
  dark: {
    bg: "bg-slate-950", 
    text: "text-slate-200",
    textMuted: "text-slate-400",
    heading: "text-white",
    card: "bg-slate-900/60 backdrop-blur-xl border border-white/10 shadow-lg shadow-black/50 rounded-[2rem]",
    sidebar: "bg-black/80 backdrop-blur-xl border-r border-white/5",
    sidebarText: "text-slate-500 hover:text-slate-200",
    sidebarActive: "bg-gradient-to-r from-orange-600 to-red-600 text-white shadow-orange-900/40 shadow-lg",
    input: "bg-slate-800/50 border border-slate-700 focus:bg-slate-800 focus:ring-2 focus:ring-orange-500/20 focus:border-orange-500 transition-all rounded-2xl text-slate-200 placeholder:text-slate-600",
    tableHeader: "bg-slate-800/50 text-slate-400 font-bold uppercase tracking-wider",
    tableRow: "hover:bg-white/5 border-b border-slate-800 last:border-0 transition-colors",
    badge: {
      Draft: "bg-slate-800 text-slate-400 border-slate-700",
      Sent: "bg-blue-900/30 text-blue-400 border-blue-800/50",
      "Follow Up": "bg-orange-900/30 text-orange-400 border-orange-800/50",
      "Order Confirmed": "bg-green-900/30 text-green-400 border-green-800/50",
      Rejected: "bg-red-900/30 text-red-400 border-red-800/50"
    }
  },
  oceanBreeze: {
    bg: "bg-gradient-to-br from-teal-50 to-cyan-100", 
    text: "text-teal-900",
    textMuted: "text-teal-700/70",
    heading: "text-teal-950 tracking-tight",
    card: "bg-white/40 backdrop-blur-3xl border border-white/50 shadow-xl shadow-cyan-900/5 rounded-[2rem]",
    sidebar: "bg-white/30 backdrop-blur-3xl border-r border-white/40 shadow-2xl shadow-cyan-900/10",
    sidebarText: "text-teal-800/70 font-bold hover:text-teal-600 transition-colors",
    sidebarActive: "bg-gradient-to-r from-teal-500 to-cyan-500 text-white shadow-lg shadow-teal-500/30 scale-105",
    input: "bg-white/40 border border-white/60 focus:bg-white/80 focus:border-teal-400 focus:ring-4 focus:ring-teal-500/10 transition-all rounded-2xl text-teal-900 placeholder:text-teal-600/50 font-medium",
    tableHeader: "bg-teal-100/50 text-teal-900/80 font-black uppercase tracking-wider border-b border-teal-200/50",
    tableRow: "hover:bg-white/30 border-b border-teal-100/50 last:border-0 transition-colors duration-200",
    badge: {
      Draft: "bg-white/50 text-teal-700 border-teal-200 backdrop-blur-md",
      Sent: "bg-cyan-100/80 text-cyan-700 border-cyan-300 backdrop-blur-md",
      "Follow Up": "bg-orange-100/80 text-orange-600 border-orange-300 backdrop-blur-md",
      "Order Confirmed": "bg-emerald-100/80 text-emerald-700 border-emerald-300 backdrop-blur-md",
      Rejected: "bg-rose-100/80 text-rose-600 border-rose-300 backdrop-blur-md"
    }
  },
  midnightNeon: {
    bg: "bg-slate-950", 
    text: "text-fuchsia-100",
    textMuted: "text-fuchsia-300/50",
    heading: "text-white tracking-tight",
    card: "bg-black/40 backdrop-blur-2xl border border-fuchsia-500/20 shadow-[0_0_30px_rgba(192,38,211,0.05)] hover:shadow-[0_0_30px_rgba(192,38,211,0.15)] rounded-[2rem]",
    sidebar: "bg-black/60 backdrop-blur-3xl border-r border-fuchsia-500/20 shadow-[0_0_50px_rgba(192,38,211,0.1)]",
    sidebarText: "text-fuchsia-300/60 font-bold hover:text-fuchsia-300 transition-colors",
    sidebarActive: "bg-gradient-to-r from-fuchsia-600 to-purple-600 text-white shadow-[0_0_20px_rgba(192,38,211,0.4)] scale-105",
    input: "bg-fuchsia-950/30 border border-fuchsia-500/30 focus:bg-fuchsia-900/30 focus:border-fuchsia-400 focus:ring-4 focus:ring-fuchsia-500/20 transition-all rounded-2xl text-fuchsia-100 placeholder:text-fuchsia-300/40 font-medium",
    tableHeader: "bg-fuchsia-900/20 text-fuchsia-300 font-black uppercase tracking-wider border-b border-fuchsia-500/20",
    tableRow: "hover:bg-fuchsia-900/20 border-b border-fuchsia-500/10 last:border-0 transition-colors duration-200",
    badge: {
      Draft: "bg-fuchsia-900/40 text-fuchsia-300 border-fuchsia-500/30 backdrop-blur-md",
      Sent: "bg-blue-900/40 text-blue-300 border-blue-500/30 backdrop-blur-md",
      "Follow Up": "bg-amber-900/40 text-amber-300 border-amber-500/30 backdrop-blur-md",
      "Order Confirmed": "bg-emerald-900/40 text-emerald-300 border-emerald-500/30 backdrop-blur-md",
      Rejected: "bg-rose-900/40 text-rose-300 border-rose-500/30 backdrop-blur-md"
    }
  }
};


const INITIAL_USERS = [
  { id: '1', username: 'admin', password: '123', role: 'admin', name: 'Administrator', region: 'LOCAL' }
];
const INITIAL_PRODUCTS = [];
const INITIAL_CUSTOMERS = [];
const INITIAL_QUOTES = [];


const DEFAULT_RATES = { USD: 84.00, EUR: 90.00, GBP: 105.00, AED: 22.80 };
const DEFAULT_BANK_DETAILS = { bankName: '', accountName: '', accountNumber: '', ifsc: '', branch: '' };

const CATEGORY_SORT_ORDER = [
  'WET PROCESS MACHINES', 
  'SAMPLE MACHINES', 
  'DRY PROCESS MACHINES', 
  'FINISHING MACHINES', 
  'SPARES',
  'SUSTAINABLE TECHNOLOGIES'
];

const DEFAULT_CATEGORIES = CATEGORY_SORT_ORDER;

const DEFAULT_TERMS = { text: "1. Validity: This quotation is valid for 30 days from the date of issue.\n2. Payment: 50% advance along with purchase order, balance before dispatch.\n3. Delivery: Ex-works our factory. Shipping charges extra at actuals.\n4. Taxes: GST as applicable will be charged extra.\n5. Warranty: 12 months against manufacturing defects from the date of supply." };

const COMPANY_INFO = {
  name: 'ONYX MACHINERY PRIVATE LIMITED',
  address: '40, UDAY INDUSTRIAL ESTATE, OPP.GIDC, ODHAV',
  city: 'AHMEDABAD - 382 415. GUJARAT, INDIA.',
  email: 'sales@onyxmachinery.com',
  website: 'www.onyxmachinery.in',
  phone: '+91 70 41 40 35 91 | +91 72 27 82 82 84',
  taxId: 'GSTIN: 24AACCO7920N1Z6'
};

const STATUS_OPTIONS = [
  { value: 'Draft', label: 'Draft', color: 'bg-slate-100 text-slate-600 border-slate-200' },
  { value: 'Sent', label: 'Sent', color: 'bg-blue-50 text-blue-600 border-blue-200' },
  { value: 'Follow Up', label: 'Follow Up', color: 'bg-orange-50 text-orange-600 border-orange-200' },
  { value: 'Order Confirmed', label: 'Order Confirmed', color: 'bg-green-50 text-green-600 border-green-200' },
  { value: 'Rejected', label: 'Rejected', color: 'bg-red-50 text-red-600 border-red-200' },
];


export { THEMES, HOSTINGER_API_URL, INITIAL_USERS, INITIAL_PRODUCTS, INITIAL_CUSTOMERS, INITIAL_QUOTES, DEFAULT_RATES, DEFAULT_BANK_DETAILS, CATEGORY_SORT_ORDER, DEFAULT_CATEGORIES, DEFAULT_TERMS, COMPANY_INFO, STATUS_OPTIONS };
